import { useTranslation } from 'react-i18next';
import { Part2Appointment } from '../utils';
import { NachversandCard } from './NachversandCard';
import { Part2AppointmentDetails } from './Part2AppointmentDetails';

export const BookedCard = ({
  appointment,
}: {
  appointment: Part2Appointment;
}) => {
  const { t } = useTranslation('versand');

  return (
    <NachversandCard title={t('Booked.Title')}>
      <Part2AppointmentDetails appointment={appointment} />
    </NachversandCard>
  );
};
